import React from 'react';

import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import { RoundedSectionType } from '../../../common/RoundedSection/RoundedSection';
import { Guides } from '../../../homepage/Components/Guides/Guides';

export const GuidesSection = ({ theme }: { theme?: RoundedSectionType }) => {
  const onGuidesSectionLoad = (label: string) => LANDING_PAGE_EVENTS.SECTION_LOAD({
    label,
    name: LANDING_PAGE_SECTIONS_NAMES.GUIDES,
  });

  return (
    <Guides onLoad={onGuidesSectionLoad} theme={theme} />
  );
};
